import AppLink from '@chegg-wt/core/components/AppLink'
import {
  TextContainer,
  TextContentContainer,
  HeadingText,
  SubHeadingText,
  TextContent,
  TextContentHeading,
  TextHeadingContainer,
  HeadingButton,
  TextElement,
} from '../styled'
import { BannerTextProps } from './types'

const BannerText = ({
  subHeading,
  heading,
  textTheme,
  textContentHeadingFirst,
  textContentHeadingSecond,
  textContentHeadingThird,
  textContentFirst,
  textContentSecond,
  textContentThird,
  headingIcon,
  textIconFirst,
  textIconSecond,
  textIconThird,
  testId,
  redirect,
}: BannerTextProps): JSX.Element => {
  return (
    <TextContainer data-test={testId}>
      <TextHeadingContainer>
        <SubHeadingText textTheme={textTheme}>
          {headingIcon}
          <span>{subHeading}</span>
        </SubHeadingText>

        <HeadingText textTheme={textTheme}>{heading}</HeadingText>
        <AppLink route={redirect}>
          <HeadingButton textTheme={textTheme} href="#">
            Get started
          </HeadingButton>
        </AppLink>
      </TextHeadingContainer>

      <TextContentContainer>
        <TextElement>
          {textIconFirst}
          <div>
            <TextContentHeading textTheme={textTheme}>
              {textContentHeadingFirst}
            </TextContentHeading>
            <TextContent textTheme={textTheme}>{textContentFirst}</TextContent>
          </div>
        </TextElement>

        <TextElement>
          {textIconSecond}
          <div>
            <TextContentHeading textTheme={textTheme}>
              {textContentHeadingSecond}
            </TextContentHeading>
            <TextContent textTheme={textTheme}>{textContentSecond}</TextContent>
          </div>
        </TextElement>

        {textContentHeadingThird && (
          <TextElement>
            {textIconThird}
            <div>
              <TextContentHeading textTheme={textTheme}>
                {textContentHeadingThird}
              </TextContentHeading>
              <TextContent textTheme={textTheme}>{textContentThird}</TextContent>
            </div>
          </TextElement>
        )}
      </TextContentContainer>
    </TextContainer>
  )
}

export default BannerText
